<template>
  <div>
    <el-divider></el-divider>
    <el-checkbox v-model="financeFormData.auditInvoice" class="form-line">审核发票原件</el-checkbox>
    <br />
    <el-checkbox
      v-model="financeFormData.reminder"
      class="form-line"
      v-show="financeFormData.auditInvoice"
    >向制单人催单</el-checkbox>
  </div>
</template>

<script>
const initialFinanceFormData = {
  auditInvoice: true,
  reminder: true
};
export default {
  props: {
    currentEditNode: {
      type: Object
    },
    moddle: {
      type: Object
    }
  },
  data() {
    return {
      financeFormData: this.$js.deepCopyObj(initialFinanceFormData)
    };
  },
  methods: {
    initFormData(initData) {
      if (!initData) {
        this.financeFormData = initialFinanceFormData;
        return;
      }
      this.financeFormData = initData;
    },
    createNotifierBpmnData() {
      this.currentEditNode.set("nodeOption", this.financeFormData);
    }
  }
};
</script>

<style scoped>
.form-line {
  height: 40px;
  line-height: 40px;
}
</style>